import { connect } from 'react-redux'

import { config } from 'hungry-core2'
import coordinators from '@coordinators'
import services from '@services'
import presenters from '@presenters'
import { HandleError } from '@coordinators/composed'

import { EditMarketplaceUserModal } from '@components/marketplaceUsers'

interface State {
  router: {
    location: {
      port: number
    }
  }
}
const mapStateToProps = (state: State) => {
  const { router } = state
  const port = router.location.port === 3000 ? 3001 : 3000
  const uri =
    config.admin_url +
    (config.admin_url === 'http://localhost' ? `:${port}` : '')

  return {
    uri,
  }
}

const mapDispatchToProps = () => {
  const { RestService } = services
  const { UpdateMarketplaceUser, UnlinkAccount } = coordinators
  const { pResponseGeneric } = presenters.Api

  const updateMarketplaceUser = UpdateMarketplaceUser({
    RestService,
    pResponseMarketplaceUser: pResponseGeneric,
    HandleError,
  })

  const unlinkAccount = UnlinkAccount({
    RestService,
    HandleError,
  })

  return {
    updateMarketplaceUser,
    unlinkAccount,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditMarketplaceUserModal)
